module.exports = __webpack_public_path__ + "static/ziggy_dehaan-367fc1cb7f3d3e306a9515942bfc4f7f.jpg";